import { isBrandingDesktopAdUnit, isMailAdUnit, AdUnit, Collapse } from 'mk/ox/hbAdUnits';
import { cacheLast } from 'mk2/helpers/cache';

const maxHeightWithAdCache = cacheLast(true);

/**
 * Returns the maximum height of an ad unit based on the screen size and ad unit configuration.
 * If the ad unit is configured to collapse, it returns null.
 */
function getMaxHeightWithAdUncached(adUnit: AdUnit, isMobile: boolean): number | null {
    const shouldDisplayPlaceholder =
        adUnit.collapse === Collapse.NEVER || adUnit.collapse === Collapse.AFTER_FETCH;

    if (!shouldDisplayPlaceholder) return null;

    let maxScreenHeight: number | null = null;

    const screenWidth = typeof window !== 'undefined'
        ? document.body.clientWidth
        : isMobile
            ? 599
            : 980;

    for (const ssc of adUnit.sizeConfig) {
        if (ssc.minScreenWidth <= screenWidth) {
            for (const [width, height] of ssc.bannerSizes) {
                const isHeightBetter = maxScreenHeight === null || height > maxScreenHeight;
                const isNotBranding = !(height === 1400 && isBrandingDesktopAdUnit(adUnit));
                const isNotMail = !isMailAdUnit(adUnit);

                if (isHeightBetter && isNotBranding && isNotMail) {
                    maxScreenHeight = height;
                }
            }
        }
    }

    const allowedHeights = new Set([50, 60, 82, 90, 100, 112, 117, 120, 122, 125, 180, 200, 210, 250, 280, 300, 600]);
    return allowedHeights.has(maxScreenHeight!) ? maxScreenHeight : null;
}


export function getMaxHeightWithAd(adUnit: AdUnit, isMobile: boolean) {
    return maxHeightWithAdCache(() => getMaxHeightWithAdUncached(adUnit, isMobile), adUnit, typeof window);
}
